<template>
  <div>
    <div style="height: 250px;"/>
  
    <v-layout justify-center>
      <h1 class="fade-in delay1" style="font-size: 50px;">商品購入</h1>
    </v-layout>

    <v-layout justify-center>
      <v-card
        class="fade-in delay1"
        color="transparent"
        elevation="0"
        width="800"
      >
        <v-card-text style="font-size: 15px;">
          このページでは、利用者が仮想通貨を使用して、拠点で販売されている商品を購入する機能をご紹介します。<br/>
          利用者が商品を購入するには、「利用者登録」「仮想通貨のチャージ」「商品の購入」の流れを踏みますが、
          ここでは、「利用者登録」と「商品の購入」の機能を取り上げ、また、購入後の「購入履歴一覧」の機能もご紹介します。
          「仮想通貨のチャージ」に関しては、管理者アプリ上で行われる処理であるため、このぺーじでの説明を省略します。<br/><br/>
        </v-card-text>
      </v-card>
    </v-layout>

    <div style="height: 300px;"/>

    <div id="user">
      <v-layout justify-center>
        <h1>ユーザー登録</h1>
      </v-layout>

      <v-row justify="center" no-gutters class="mt-5">
        <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
          <pics-slider :pics="getPics(pics.users)"/>

          <slider-dialog :pics="getPics(pics.users)"/>
        </v-col>

        <v-col align-self="center">
          <v-card
            color="transparent"
            elevation="0"
          >
            <v-card-text style="font-size: 15px;">
              利用者が仮想通貨で購入を行うためのアカウントを作成する機能です。
              ユーザーアカウントが作ることで初めて、管理者からの仮想通貨の発行を受けることができるようになります。
              また、ユーザー登録には自身のGoogleアカウントを使用するため、持っていない場合は新たに作成する必要があります。<br/><br/>

              まず、利用者はPCのWebブラウザを使用し、本アプリの「/user/signin」のパスにアクセスします。
              アクセスを行うとユーザー登録のフォームが現れます。
              入力項目は「名前」のみです。この名前がウォレットアドレスの作成に使用されます。
              入力完了後、フォームの下にある「Sign in with Google account」ボタンを押下し、登録に使用する自分のGoogleアカウント選択します。
              選択後、サーバにリクエストが送られ、利用者専用のアカウントが作成されます。<br/><br/>

              アカウント作成が完了すると、利用者用のスマホアプリから、本アプリケーションを利用できるようになっています。
              次のセクション以降、もしくは「個人間送金」の機能においては、スマホアプリからサービスを利用してください。
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div style="height: 300px;"/>

    <div id="buy">
      <v-layout justify-center>
        <h1>商品購入</h1>
      </v-layout>

      <v-row justify="center" no-gutters class="mt-5">
        <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
          <pics-slider :pics="getPics(pics.buys)"/>

          <slider-dialog :pics="getPics(pics.buys)"/>
        </v-col>

        <v-col align-self="center">
          <v-card
            color="transparent"
            elevation="0"
          >
            <v-card-text style="font-size: 15px;">
              利用者がある拠点において、商品を購入する際に決済を行う機能です。<br/>
              ユーザー登録を行い、管理者から発行を受けて仮想通貨のチャージを行うと、この機能を利用して商品の購入が可能になります。
              まず、利用者はスマホアプリを開き、ユーザー登録で使用したGoogleアカウントでログインを行います。
              ログインが完了すると、自分の仮想通貨の残高と、商品を販売している拠点の一覧が表示されるので、商品購入を行う拠点を選択します。              
              例えば、「Tokyo」という拠点で商品を購入する場合は、拠点一覧の「Tokyo」を選択してください。<br/><br/>

              拠点が選択されると、そこで販売されている商品の一覧が表示されます。
              ここでは、自分の欲しい商品を欲しい個数だけタップし、商品をカートに追加していきます。
              商品の選択ができたら、スマホ右上に現れるカートボタンを押し、購入する商品の確認を行います。
              確認ページでは、「購入する商品とその個数」「合計金額」「支払先拠点」が表示されるので、これらの項目をチェックし、
              正しいことを確認できた場合、右上の購入ボタンを押し、購入リクエストを送ります。<br/><br/>

              リクエストが処理されると、初期の拠点選択ページに戻り、バナーにて完了通知がされ、一連の購入処理が完了します。
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div style="height: 300px;"/>

    <div id="history">
      <v-layout justify-center>
        <h1>購入履歴閲覧</h1>
      </v-layout>

      <v-row justify="center" no-gutters class="mt-5">
        <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
          <pics-slider :pics="getPics(pics.histories)"/>

          <slider-dialog :pics="getPics(pics.histories)"/>
        </v-col>

        <v-col align-self="center">
          <v-card
            color="transparent"
            elevation="0"
          >
            <v-card-text style="font-size: 15px;">
              利用者が、自身の行った商品の購入履歴を閲覧できる機能です。<br/>
              これによって、利用者は自分が使用したお金と支払い先を確認することができ、支出管理や支払の証明に使用できます。<br/><br/>

              履歴確認を行うには、スマホアプリにログイン後、画面下のナビゲーションより「History」を選択し履歴閲覧ページを開きます。
              履歴閲覧ページでは、月毎に履歴がまとめられており、主に2つの項目が閲覧できます。
              1つ目は、「ひと月分の合計支払額」です。ここでは他に、「仮想通貨の合計チャージ額」や個人間送金での「受取合計金額」「送金合計金額」が確認できます。
              2つ目は、「支払1件ごとの詳細な履歴」です。支払履歴のカードをタップすると、「支払先」や「購入商品」などのより詳細な履歴を確認することができます。<br/><br/>

              履歴閲覧ページは月毎に履歴が表示されるため、他の月を確認したい場合は横にスワイプし、ひと月ごとに移動して確認を行ってください。
              以上の操作で、利用者は現在までの購入履歴を確認することができるようになっています。
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div style="height: 100px;"/>

  
  </div>
</template>

<script>
import scrollToMixin from '../../../mixin/scrollToMixin'
import PicsSlider from '../components/PicsSlider'
import SliderDialog from '../components/SliderDialog.vue';

export default {
  mixins: [scrollToMixin],
  components: {
    PicsSlider,
    SliderDialog,
  },
  data: () => ({
    pics: {
      users: ["register_1.png", "register_2.png", "register_3.png"],
      buys: ["buy_1.png", "buy_2.png", "buy_3.png", "buy_4.png"],
      histories: ["buy_history_1.png", "buy_history_2.png"],
    }
  }),
  methods: {
    /**@param {Array<String>} pics */
    getPics: function(pics){
      const img = [];
      pics.map((value) => {
        img.push(require("../../../images/user/" + value));
      })
      return img;
    }
  }
}
</script>